import { mastercardEventEmitter_injector } from './MastercardEventEmitter.class';
export default mastercardEventEmitter_injector();